<div class="cell-view">
  <div class="inner-view">{{ rowData[fieldName]?.cronExpression }}</div>
  <div *ngIf="editable; else readonly" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="CronCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit('Cron', !editable)"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="CronCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
  <ng-template #readonly>
    <div class="edit-menu">
      <button
        pButton
        id="cancelRowSelection"
        data-cy="CronCell_Button_view"
        icon="pi pi-eye"
        (click)="onEdit('Cron', !editable)"
      ></button>
    </div>
  </ng-template>
</div>
